import { TableFieldModel } from '@/model/TableList'

export const FieldMaterialTable: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '物料编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '物料名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '物料品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '物料型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialUnit',
    fieldName: '物料单位'
  }
]
